import { useInstance } from '../../support/ioc/useInstance';
import { dayjs } from '../../support/helpers/dayjs.ts';
import { DateTimePicker } from '../../components/picker/DateTimePicker.tsx';
import { DurationPicker } from '../../components/picker/DurationPicker.tsx';
import { AlertPresenter } from '../../app/AlertBinder.tsx';
import { ICommonMissionState } from '../model/ICommonMissionState.ts';
import { DrawerLabel } from '../../components/drawer/DrawerLabel.tsx';
import { ITimeChangeSource } from '../model/NewMissionState.ts';
import { PickerWrapper } from '../../components/picker/PickerWrapper.tsx';
import { getTimezone } from '../../support/helpers/format.ts';

export const MissionTimesEditor: React.FC<{mission: ICommonMissionState, source: ITimeChangeSource }>  = ({ mission, source }) => {
    const alert = useInstance(AlertPresenter);

    const onChangeStartTime = async (startTime: string) => {
        try {
            await mission.setStartTime(startTime, source);
        } catch (e: any) {
            e.message = `Failed setting mission start time: ${e.message}`;
            alert.showAndLogError(e);
        }
    };

    const onChangeDuration = async (duration: number) => {
        try{
            await mission.setDurationMinutes(duration, source);
        } catch (err: any){
            err.message = `Failed setting mission duration: ${err.message}`;
            alert.showAndLogError(err);
        }
    };

    const fromDate = dayjs().toISOString();
    const toDate = dayjs().add(90, 'd').toISOString();
    const timezone = getTimezone(mission.getLocation()!);

    return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 0}}>
            <div>
                <DrawerLabel text="Date and Time" />
                <PickerWrapper>
                    <DateTimePicker color="primary" fromDate={fromDate} toDate={toDate} minuteIncrement={5} dateTime={mission.getStartTime()} timezone={timezone} onChange={onChangeStartTime} />
                </PickerWrapper>
            </div>
            <div>
                <DrawerLabel text="Duration" />
                <PickerWrapper>
                    <DurationPicker color="primary" durationMinutes={mission.getDurationMinutes()} onChange={onChangeDuration} />
                </PickerWrapper>
            </div>
        </div>
    );
};
